window.addEventListener('page.init', (e) => {
    window.fbq('track', 'PageView');
    window.fbq('track', 'ViewContent');
})

window.addEventListener('application.complete', (e) => {
    window.fbq('track', 'finance_complete');
})

window.addEventListener('lead.test_drive.desktop', (e) => {
    window.fbq('track', 'desktop_test_drive_modal');
})

window.addEventListener('lead.test_drive.mobile', (e) => {
    window.fbq('track', 'mobile_test_drive_modal');
})

window.addEventListener('lead.listing_enquire', (e) => {
    window.fbq('track', 'modal_enquire_about_this_car');
})

window.addEventListener('lead.contact', (e) => {
    window.fbq('track', 'email_me_about_this_car');
})

window.addEventListener('customer.register', (e) => {
    window.fbq('track', 'js_new_subscriber');
})

window.addEventListener('lead.branch_enquiry', (e) => {
    window.fbq('track', 'modal_branch_enquiry');
})

window.addEventListener('lead.trade_id', (e) => {
    window.fbq('track', 'new_tradein');
})

window.addEventListener('lead.click_email', (e) => {
    window.fbq('track', 'email_clicks_web');
})